import React from "react";
import { Box, Typography } from "@mui/material";

const TopViewedProductsChart = () => (
  <Box sx={{ p: 2, minHeight: 200, backgroundColor: "#f8fafc", borderRadius: 2 }}>
    <Typography sx={{ fontFamily: "Rubik", color: "#64748b", fontSize: 14 }}>
      Prodotti più visualizzati: in attesa di chiarimenti su metriche e backend.
    </Typography>
  </Box>
);

export default TopViewedProductsChart;
